import { Map } from 'immutable';
import Constants from '../../constants';
import { requestStateReducer } from '../helpers/views';

export const DEFAULT_STATE = Map({});

const votingRequest = requestStateReducer([Constants.VOTE_UP, Constants.VOTE_DOWN], DEFAULT_STATE);

export default votingRequest;
